(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["globo-offer-bubble"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";
  if (window.GloboOfferBubble) return;
  var SESSION_KEY = "gob_auto_opened";

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve, reject) {
      var ta = document.createElement("textarea");
      ta.value = text; ta.setAttribute("readonly", "");
      ta.style.cssText = "position:fixed;top:-1000px;left:-1000px;opacity:0";
      document.body.appendChild(ta); ta.select();
      try { document.execCommand("copy") ? resolve() : reject(new Error("copy failed")); }
      catch (e) { reject(e); } finally { document.body.removeChild(ta); }
    });
  }
  function sGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function sSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }

  function init(root) {
    if (!root || root.__gob) return root && root.__gob;
    var bubble = root.querySelector(".gob-bubble"), overlay = root.querySelector(".gob-overlay"),
        modal = root.querySelector(".gob-modal"), closeBt = root.querySelector(".gob-close"),
        copyBt = root.querySelector(".gob-copy"), codeEl = root.querySelector(".gob-code");
    if (!bubble || !overlay || !modal) return null;

    var code = root.getAttribute("data-code") || (codeEl ? codeEl.textContent.trim() : "");
    var copyLabel = copyBt ? copyBt.textContent : "";
    var copiedLabel = root.getAttribute("data-copied-text") || "Copied!";
    var lastFocus = null, resetTimer = null;

    // Move to <body>: a theme wrapper with transform/filter/overflow would otherwise break position: fixed.
    if (root.parentNode !== document.body) document.body.appendChild(root);

    function focusables() { return modal.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])'); }
    function onKey(e) {
      if (e.key === "Escape" || e.key === "Esc") { close(); return; }
      if (e.key === "Tab") {
        var f = focusables(); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    function open() {
      if (!overlay.hidden) return;
      lastFocus = document.activeElement;
      overlay.hidden = false;
      bubble.setAttribute("aria-expanded", "true");
      document.addEventListener("keydown", onKey, true);
      (copyBt || closeBt || modal).focus();
    }
    function close() {
      if (overlay.hidden) return;
      overlay.hidden = true;
      bubble.setAttribute("aria-expanded", "false");
      document.removeEventListener("keydown", onKey, true);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function destroy() { close(); root.__gob = null; if (root.parentNode) root.parentNode.removeChild(root); }

    bubble.addEventListener("click", open);
    if (closeBt) closeBt.addEventListener("click", close);
    overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });
    if (copyBt) copyBt.addEventListener("click", function () {
      copyText(code).then(function () {
        copyBt.textContent = copiedLabel; copyBt.classList.add("is-copied");
      }, function () {
        if (codeEl && window.getSelection) {
          var r = document.createRange(); r.selectNodeContents(codeEl);
          var s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
        }
      });
      clearTimeout(resetTimer);
      resetTimer = setTimeout(function () { copyBt.textContent = copyLabel; copyBt.classList.remove("is-copied"); }, 2000);
    });

    var delay = parseInt(root.getAttribute("data-open-delay"), 10);
    if (!isNaN(delay) && !sGet(SESSION_KEY)) setTimeout(function () { sSet(SESSION_KEY, "1"); open(); }, Math.max(0, delay));

    root.__gob = { open: open, close: close, destroy: destroy };
    return root.__gob;
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll("[data-gob]");
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  window.GloboOfferBubble = {
    init: initAll,
    open: function () { var g = init(document.querySelector("[data-gob]")); g && g.open(); },
    close: function () { var r = document.querySelector("[data-gob]"); r && r.__gob && r.__gob.close(); }
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initAll(); });
  else initAll();

  // Theme editor. The root lives in <body> (moved by init), so find it by section id.
  function bySection(e) { return e.detail && document.getElementById("gob-" + e.detail.sectionId); }
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
  document.addEventListener("shopify:section:unload", function (e) {
    var r = bySection(e); r && (r.__gob ? r.__gob.destroy() : r.parentNode && r.parentNode.removeChild(r));
  });
  document.addEventListener("shopify:section:select", function (e) { var g = init(bySection(e)); g && g.open(); });
  document.addEventListener("shopify:section:deselect", function (e) { var r = bySection(e); r && r.__gob && r.__gob.close(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
